import React, {useEffect, useState} from 'react';
import {
    ADMIN_GET_CSBATTLE_LEADERBOARD, ADMIN_GET_CSBATTLE_MONTHS, HOMEPAGE_LEADERBOARDPRIZES_CSBATTLE,
} from "../../../queries/queries";
import {useLazyQuery} from "@apollo/client";
import {number_format} from "../../../helpers";
import moment from "moment";
import * as XLSX from "xlsx";
import csbattleCoin from "../../../resources/csbattle_coin.svg";

const AdminCsbattle = () => {

    const [leaderboardEntries, setLeaderboardEntries] = useState([]);
    const [leaderboardMonths, setLeaderboardMonths] = useState([]);
    const [leaderboardPrizes, setLeaderboardPrizes] = useState([]);

    // Calculate current period's month/year (matching API calculation)
    const fixedStartDate = moment("2025-12-09", "YYYY-MM-DD").startOf("day");
    const today = moment().startOf("day");
    const daysSinceStart = today.diff(fixedStartDate, "days");
    const periodNumber = Math.floor(daysSinceStart / 30);
    const periodStart = fixedStartDate.clone().add(periodNumber * 30, "days");
    const currentPeriodMonth = periodStart.month() + 1;
    const currentPeriodYear = periodStart.year();

    const [activeMonth, setActiveMonth] = useState(currentPeriodMonth);
    const [activeYear, setActiveYear] = useState(currentPeriodYear);

    const [getLeaderboardPrizes] = useLazyQuery(HOMEPAGE_LEADERBOARDPRIZES_CSBATTLE, {
        fetchPolicy: 'cache-and-network', onCompleted: (e) => {
            setLeaderboardPrizes(e.getLeaderboardPrizesCsbattle);
        }, onError: () => console.log("API Request failed - if this keeps happening, report to developer!")
    });

    const [getLeaderboardMonths] = useLazyQuery(ADMIN_GET_CSBATTLE_MONTHS, {
        fetchPolicy: 'cache-and-network', onCompleted: (e) => {
            setLeaderboardMonths(e.getLeaderboardCsbattleMonths);
        }, onError: () => console.log("API Request failed - if this keeps happening, report to developer!")
    });

    const [getLeaderboard] = useLazyQuery(ADMIN_GET_CSBATTLE_LEADERBOARD, {
        fetchPolicy: 'cache-and-network', onCompleted: (e) => {
            setLeaderboardEntries(e.adminGetLeaderboardCsbattle);
            getLeaderboardPrizes();
        }, onError: () => console.log("API Request failed - if this keeps happening, report to developer!")
    });

    const setActivePeriod = (month, year) => {
        setActiveMonth(month);
        setActiveYear(year);
        getLeaderboard({
            variables: {
                month: month, year: year
            }
        });
    }

    useEffect(() => {
        getLeaderboardMonths();
        getLeaderboard({
            variables: {
                month: currentPeriodMonth,
                year: currentPeriodYear
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getRewardAtPosition = position => {
        return leaderboardPrizes[position] ? leaderboardPrizes[position].Reward : 0;
    };

    const doDownloadExcel = () => {
        const parsedExport = Object.assign({}, leaderboardEntries);

        for (const [index, item] of Object.entries(parsedExport)) {
            const {__typename, PlayerImage, ...rest} = item;
            parsedExport[index] = {...rest, Prize: getRewardAtPosition(index)};
        }

        const worksheet = XLSX.utils.json_to_sheet(Object.values(parsedExport));
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "CSBattle Leaderboard");
        XLSX.writeFile(workbook, `CSBattleLeaderboard_${activeYear}-${activeMonth}.xlsx`);
    }

    return (

        <div className="card text-bg-dark">
            <div className="card-header d-flex justify-content-between align-items-center">
                CSBattle
                <button type="button" onClick={doDownloadExcel} className="btn">Export</button>
            </div>

            <div className="card-body p-0">

                <div className="col-md-12 text-center mt-2 mb-2">
                    <div className="btn-group" role="group" aria-label="Basic example">
                        {leaderboardMonths.map(leaderboardMonth => <button
                            key={`${leaderboardMonth.Month}-${leaderboardMonth.Year}`}
                            type="button"
                            onClick={() => setActivePeriod(leaderboardMonth.Month, leaderboardMonth.Year)}
                            className={`btn btn-secondary ${activeYear === leaderboardMonth.Year && activeMonth === leaderboardMonth.Month ? 'active' : ''}`}>{leaderboardMonth.Month}/{leaderboardMonth.Year}</button>)}
                    </div>
                </div>

                <table className="table table-dark table-striped">
                    <thead>
                    <tr>
                        <th>
                            #
                        </th>
                        <th>
                            Player Name
                        </th>
                        <th>
                            Player ID
                        </th>
                        <th>
                            Wagered
                        </th>
                        <th>
                            Prize
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {leaderboardEntries && leaderboardEntries.length > 0 ? (<>
                        {leaderboardEntries.map((row, index) => {
                            return (<tr key={index}>
                                <th scope="row">
                                    {index + 1}
                                </th>
                                <td>
                                    {row?.PlayerName}
                                </td>
                                <td>
                                    {row?.PlayerId}
                                </td>
                                <td>
                                    <img src={csbattleCoin} style={{height: '16px'}} alt=""/> {number_format(row?.WageredAmount)}
                                </td>
                                <td>
                                    <img src={csbattleCoin} style={{height: '16px'}} alt=""/> {number_format(getRewardAtPosition(index))}
                                </td>
                            </tr>);
                        })}
                    </>) : (<></>)}

                    </tbody>
                </table>

            </div>
        </div>);

};

export default AdminCsbattle;

